import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    isSecretary = false;
    isClassRegisterEditor = false;
    isCertificateEditor = false;

    async initParams(): Promise<boolean> {
        this.isSecretary = this.service.isSecretary();
        this.isClassRegisterEditor = this.service.isClassRegisterEditor();
        this.isCertificateEditor = this.service.isCertificateEditor();
        return true;
    }
}
